import React from 'react';
import './LoginPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import useSEO from '../hooks/useSEO';

function LoginPage() {
  useSEO({
    title: "Portails de Connexion Sécurisés | Administration, Enseignants, Parents & Élèves",
    description: "Accédez aux portails de gestion et de suivi scolaire du Groupe Scolaire et Universitaire Les Palmiers : Administration, Professeurs, Parents et Élèves.",
    keywords: "connexion GSU Les Palmiers, portail élève Togba, espace parent école Bénin, portail enseignant Les Palmiers, portail administration",
    canonicalUrl: "https://gsulespalmiers.bj/login"
  });

  const portails = [
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
          <line x1="9" y1="9" x2="15" y2="9"/>
          <line x1="9" y1="15" x2="15" y2="15"/>
          <line x1="9" y1="12" x2="15" y2="12"/>
        </svg>
      ),
      title: 'Portail Administration',
      description: 'Espace réservé au personnel administratif',
      color: '#1e5ba8',
      btnText: 'Se connecter'
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      title: 'Portail Professeur',
      description: 'Espace dédié aux enseignants pour la saisie des notes et absences',
      color: '#667eea',
      btnText: 'Se connecter'
    },
    {
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
          <path d="M6 12v5c3 3 9 3 12 0v-5"/>
        </svg>
      ),
      title: 'Portail Parents/Élèves',
      description: 'Accès aux cours, notes, emplois du temps et suivi académique',
      color: '#ff6b35',
      btnText: 'Se connecter'
    }
  ];

  const handlePortailClick = (portail) => {
    if (portail === 'Portail Administration') {
      window.navigateTo && window.navigateTo('portal-login-admin');
    } else if (portail === 'Portail Professeur') {
      window.navigateTo && window.navigateTo('portal-login-teacher');
    } else if (portail === 'Portail Parents/Élèves') {
      // Un seul portail pour parents et élèves
      window.navigateTo && window.navigateTo('portal-login-family');
    }
  };

  return (
    <div className="login-page">
      <Header />
      
      <section className="login-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Portail de <span className="highlight">Connexion</span>
            </h1>
            <p className="hero-subtitle">
              Connectez-vous à votre espace personnel pour suivre votre parcours, 
              accéder à vos ressources et gérer vos informations.
            </p>
          </div>
        </div>
      </section>

      <section className="portails-section section">
        <div className="container">
          <div className="portails-grid">
            {portails.map((portail, index) => (
              <div key={index} className="portail-card">
                <div 
                  className="portail-icon" 
                  style={{ backgroundColor: portail.color }}
                >
                  {portail.icon}
                </div>
                <h3>{portail.title}</h3>
                <p>{portail.description}</p>
                <button 
                  className="btn-portail"
                  style={{ backgroundColor: portail.color }}
                  onClick={() => handlePortailClick(portail.title)}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                    <polyline points="10 17 15 12 10 7"/>
                    <line x1="15" y1="12" x2="3" y2="12"/>
                  </svg>
                  {portail.btnText}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default LoginPage;
